import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ScrollToButton/ScrollToButton.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ScrollToButton/ScrollToButton.ts';

export const prototypeName = 'a6zL3Gk1P5idre7LvZz0Ub733plVJXFN57x7NZl7FJe2GxoJgPH4kg7V2dkWt05bgjbor0FLnRlp';
export {styles};
export {script};